// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-head{
    margin: 20px 70px;
    font-size: 18px;
    font-weight: 600
    ;
}
@media (max-width: 480px) {
  .tracking-head {
    margin: 10px 20px;
    font-size: 16px;
    text-align: center; /* optional */
  }
}
.radio-labels{
  margin-right: 70px !important;
} 
@media (max-width: 480px) {
  .radio-labels {
    margin-right: 0px;
  }
}
.radio-button{
  margin:0px 10px 0px 0px
}
@media (max-width: 480px) {
  .radio-button {
    margin: 10px 5px 0px 0px;
  }
}
:root {
  --status-icon-size: 40px;
}

.status-strip {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 30px 0;
    position: relative;
    padding: 0 10px;
  }
  
  .status-step {
    text-align: center;
    flex: 1 1;
    position: relative;
  }
  
  .status-icon {
    width: 40px;
    height: 40px;
    margin: 0 auto 10px;
    background-color: #e0e0e0;
    color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }
  
  .status-icon.completed {
    background-color: #2a9d8f;
  }
  
  .status-label {
    font-weight: 600;
    font-size: 13px;
    color: #333;
    margin-bottom: 4px;
  }
  
  .status-time,
  .status-location {
    font-size: 12px;
    color: #777;
  }
  
  .status-line {
    position: absolute;
    top: 20px;
    left: 50%;
    height: 3px;
    width: 100%;
    background-color: #e0e0e0;
    z-index: -1;
  }
  
  .status-line.completed {
    background-color: #2a9d8f;
  }
  .tracking-strip {
    display: flex;
    justify-content: space-between; /* or use space-around if you want some spacing at ends */
    align-items: flex-start;
    width: 100%;
    position: relative;
    margin: 20px 0;
    padding: 0;
  }
  
  .status-step {
    flex: 1 1;
    text-align: center;
    position: relative;
  }
  
  .status-label {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 30px;
    color: #333;
  }
  
  /* .status-icon-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #1D7C9C;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    z-index: 2;
  } */
  .status-icon-wrapper {
    width: 40px;
    width: var(--status-icon-size);
    height: 40px;
    height: var(--status-icon-size);
    border-radius: 50%;
    background-color: #1D7C9C;

    display: flex;
    justify-content: center;
    align-items: center;

    margin: 0 auto;
    position: relative;
    z-index: 2;
}

  .status-icon {
    width: 50px;
    height: 50px;
    /* filter: brightness(0) invert(1); */
  }
  
  .status-subtext {
    font-size: 12px;
    color: #555;
    margin-top: 6px;
  }
  
  .status-connector {
    position: absolute;
    top: 65px; /* vertically center the line */
    left: 10%;
    height: 5px;
    width: 100%;
    transform: translateX(50%);
    background-color: #6cd0a9;
    z-index: inherit;
  }
    
/* Card container */
.tracking-card {
  width:100%;
  margin: 5px auto;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  padding: 20px;
}

/* Table wrapper for overflow (optional) */
.tracking-table-wrapper {
  overflow-x: auto;
}

/* Table styles */
.tracking-table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Segoe UI", sans-serif;
}

/* Table headers */
.tracking-table thead th {
  background-color: #f5f6f8;
  font-weight: bold;
  color: #333;
  padding: 14px 18px;
  text-align: left;
  font-size: 14px;
  border-bottom: 1px solid #e0e0e0;
}

/* Table data cells */
.tracking-table td {
  font-weight: normal;
  color: #444;
  padding: 14px 18px;
  border-bottom: 1px solid #eaeaea;
  vertical-align: middle;
  font-size: 14px;
}

/* First row highlight */
.highlight-row {
  background-color: #e8f4fd;
}

/* Status cell with icon */
/* .status-cell {
  display: flex;
  align-items: center;
  gap: 8px;
} */
.status-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  min-height: 48px;      /* force uniform row height */
  white-space: nowrap;  /* prevent ugly wrap */
}

/* Icon */
/* .status-icon-sm 

{
  width: 20px;
  height: 20px;
} */
.mobile-timeline-card {
  max-width: 400px;
  margin: 20px auto;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  font-family: 'Segoe UI', sans-serif;
  overflow: hidden;
}

.timeline-heading {
  font-weight: 600;
  font-size: 16px;
  color: white;
  background-color: #1D7C9C;
  padding: 12px 16px;
  text-align: center;
}

.eta-strip {
  background-color: #e3f4fd;
  color: #1D7C9C;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  padding: 10px 16px;
  border-bottom: 1px solid #d0eaf5;
}

/* Timeline Grid */
.mobile-tracking-timeline {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px 16px;
}

/* Each row is 3-part: left (status), center (line + icon), right (time + location) */
.timeline-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.timeline-left,
.timeline-right {
  width: 40%;
  font-size: 13px;
}

.timeline-left .step-title {
  font-weight: 600;
  color: #333;
  text-align: right;
}

.timeline-right .step-datetime,
.timeline-right .step-location {
  color: #555;
  text-align: left;
  margin-bottom: 3px;
}

/* Center vertical icon/line */
.timeline-center {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 80px; /* controls the space between circles */
}

.circle-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: white;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #007bff; /* or gray if inactive */
}

.circle-icon img {
  width: 35px;
  height: 35px;
  /* filter: brightness(0) invert(1); */
}

.vertical-line {
  position: absolute;
  top: 32px;
  width: 2px;
  height: calc(100% - 32px);
  background-color: #1D7C9C;
  z-index: 0;
}
.status-step {
  flex: 1 1;
  text-align: center;
  position: relative;
}

/* .status-connector-gray {
  position: absolute;
  top: 65px;
  left: 5%;
  width: 100%;
  height: 5px;
  background-color: gray; 
  transform: translateX(50%);
  z-index: 0;
} */
.status-connector-blue {
  position: absolute;
  top: 65px;
  left: 9%;
  width: 100%;
  height: 5px;
  background-color: #1d7c9c; /* blue */
  transform: translateX(50%);
  z-index: 0;
}

/* .status-connector-green {
  position: absolute;
  top: 65px;
  left: 0%;
  width: 100%;
  height: 5px;
  background-color: #28a745; 
  transform: translateX(50%);
  z-index: 0;
} */
 .status-connector-green,
 .status-connector-gray {
   position: absolute;
   top: 65px;
   left: calc(50% + (40px / 2) - 2px);
   left: calc(50% + (var(--status-icon-size) / 2) - 2px);
   width: calc(100% + 6px);
   height: 5px;
   z-index: 0;
 }
.status-connector-green {
  background-color: #28a745;
}
.status-connector-gray {
  background-color: #ccc;
}

.status-icon-wrapper {
  width: 40px;
  height: 40px;
  background-color: #1d7c9c;
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.status-done {
  background-color: #28a745 !important; /* green filled circle */
}

.status-icon {
  width: 50px;
  height: 50px;
  z-index: 0;
  /* filter: brightness(0) invert(1);  */
}
.status-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot-space {
  width: 8px; /* fixed width to reserve space */
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-dot {
  width: 8px;
  height: 8px;
  background-color: #2b78e4;
  border-radius: 50%;
}


.status-connector-green-mobile {
  position: absolute;
  top: 50%; /* Starts from the center of the current circle */
  left: 50%;
  transform: translate(-50%, 0);
  width: 4px;
  height: calc(100% - 10px);          /* Stretches fully downward */
  background-color: #28a745;
  z-index: 0;
}

.status-connector-blue-mobile {
  position: absolute;
  top: 50%; /* Starts from the center of the current circle */
  left: 50%;
  transform: translate(-50%, 0);
  width: 4px;
  height: calc(100% - 10px);
  background-color: #1d7c9c; /* blue */
  z-index: 0;
}

.status-connector-gray-mobile {
  position: absolute;
  top: 50%; /* Starts from the center of the current circle */
  left: 50%;
  transform: translate(-50%, 0);
  width: 4px;
  height: calc(100% - 10px); /* Adjust height to reach next circle */
  background-color: #ccc;
  z-index: 0;
}

.invoice-details-head{
  background-color: #1D7C9C;
  color: #fff;
  padding: 15px 20px;
  display: flex;
  justify-content: "space-between";
  align-items: "center";
  font-weight: "600";
  font-size: "16px"
}
.pod-eye-icon {
  margin-top: 8px; /* Space below delivered icon */
  text-align: center;
}

.pod-eye-icon i {
  cursor: pointer;
  font-size: 18px;
}
.tracking-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: "Segoe UI", sans-serif;
}

.tracking-grid-header,
.tracking-grid-row {
  display: grid;
  grid-template-columns: 1.2fr 1.5fr 1fr 1.5fr;
  padding: 14px 18px;
  border-bottom: 1px solid #eaeaea;
  align-items: center;
}

.tracking-grid-header {
  background-color: #f5f6f8;
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.tracking-grid-row {
  font-size: 14px;
  color: #444;
}

.highlight-row {
  background-color: #eaf6ff;
}

.status-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-cell {
  white-space: nowrap;
}

.tracking-grid-expand {
  padding: 15px 30px;
  background: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/trackingLink.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf;IACA;AACJ;AACA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB,EAAE,aAAa;EACnC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,wBAAwB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,8BAA8B,EAAE,yDAAyD;IACzF,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;;;;;;;;;;KAUG;EACH;IACE,WAA8B;IAA9B,8BAA8B;IAC9B,YAA+B;IAA/B,+BAA+B;IAC/B,kBAAkB;IAClB,yBAAyB;;IAEzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS,EAAE,+BAA+B;IAC1C,SAAS;IACT,WAAW;IACX,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;EAClB;;AAEF,mBAAmB;AACnB;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;;;;GAIG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,gBAAgB,OAAO,6BAA6B;EACpD,mBAAmB,GAAG,sBAAsB;AAC9C;;AAEA,SAAS;AACT;;;;;GAKG;AACH;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,qFAAqF;AACrF;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;;;;GASG;AACH;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,yBAAyB,EAAE,SAAS;EACpC,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;;;;;;;;GASG;CACF;;GAEE,kBAAkB;GAClB,SAAS;GACT,kCAAqD;GAArD,qDAAqD;GACrD,uBAAuB;GACvB,WAAW;GACX,UAAU;CACZ;AACD;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,oCAAoC,EAAE,wBAAwB;AAChE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU,EAAE,iCAAiC;EAC7C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ,EAAE,iDAAiD;EAC3D,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,yBAAyB,WAAW,6BAA6B;EACjE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,iDAAiD;EAC3D,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,yBAAyB;EACzB,yBAAyB,EAAE,SAAS;EACpC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,iDAAiD;EAC3D,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,yBAAyB,EAAE,uCAAuC;EAClE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB;AACF;AACA;EACE,eAAe,EAAE,+BAA+B;EAChD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".tracking-head{\n    margin: 20px 70px;\n    font-size: 18px;\n    font-weight: 600\n    ;\n}\n@media (max-width: 480px) {\n  .tracking-head {\n    margin: 10px 20px;\n    font-size: 16px;\n    text-align: center; /* optional */\n  }\n}\n.radio-labels{\n  margin-right: 70px !important;\n} \n@media (max-width: 480px) {\n  .radio-labels {\n    margin-right: 0px;\n  }\n}\n.radio-button{\n  margin:0px 10px 0px 0px\n}\n@media (max-width: 480px) {\n  .radio-button {\n    margin: 10px 5px 0px 0px;\n  }\n}\n:root {\n  --status-icon-size: 40px;\n}\n\n.status-strip {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin: 30px 0;\n    position: relative;\n    padding: 0 10px;\n  }\n  \n  .status-step {\n    text-align: center;\n    flex: 1;\n    position: relative;\n  }\n  \n  .status-icon {\n    width: 40px;\n    height: 40px;\n    margin: 0 auto 10px;\n    background-color: #e0e0e0;\n    color: #fff;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n  }\n  \n  .status-icon.completed {\n    background-color: #2a9d8f;\n  }\n  \n  .status-label {\n    font-weight: 600;\n    font-size: 13px;\n    color: #333;\n    margin-bottom: 4px;\n  }\n  \n  .status-time,\n  .status-location {\n    font-size: 12px;\n    color: #777;\n  }\n  \n  .status-line {\n    position: absolute;\n    top: 20px;\n    left: 50%;\n    height: 3px;\n    width: 100%;\n    background-color: #e0e0e0;\n    z-index: -1;\n  }\n  \n  .status-line.completed {\n    background-color: #2a9d8f;\n  }\n  .tracking-strip {\n    display: flex;\n    justify-content: space-between; /* or use space-around if you want some spacing at ends */\n    align-items: flex-start;\n    width: 100%;\n    position: relative;\n    margin: 20px 0;\n    padding: 0;\n  }\n  \n  .status-step {\n    flex: 1;\n    text-align: center;\n    position: relative;\n  }\n  \n  .status-label {\n    font-weight: 600;\n    font-size: 16px;\n    margin-bottom: 30px;\n    color: #333;\n  }\n  \n  /* .status-icon-wrapper {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: #1D7C9C;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    z-index: 2;\n  } */\n  .status-icon-wrapper {\n    width: var(--status-icon-size);\n    height: var(--status-icon-size);\n    border-radius: 50%;\n    background-color: #1D7C9C;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    margin: 0 auto;\n    position: relative;\n    z-index: 2;\n}\n\n  .status-icon {\n    width: 50px;\n    height: 50px;\n    /* filter: brightness(0) invert(1); */\n  }\n  \n  .status-subtext {\n    font-size: 12px;\n    color: #555;\n    margin-top: 6px;\n  }\n  \n  .status-connector {\n    position: absolute;\n    top: 65px; /* vertically center the line */\n    left: 10%;\n    height: 5px;\n    width: 100%;\n    transform: translateX(50%);\n    background-color: #6cd0a9;\n    z-index: inherit;\n  }\n    \n/* Card container */\n.tracking-card {\n  width:100%;\n  margin: 5px auto;\n  background-color: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  padding: 20px;\n}\n\n/* Table wrapper for overflow (optional) */\n.tracking-table-wrapper {\n  overflow-x: auto;\n}\n\n/* Table styles */\n.tracking-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"Segoe UI\", sans-serif;\n}\n\n/* Table headers */\n.tracking-table thead th {\n  background-color: #f5f6f8;\n  font-weight: bold;\n  color: #333;\n  padding: 14px 18px;\n  text-align: left;\n  font-size: 14px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n/* Table data cells */\n.tracking-table td {\n  font-weight: normal;\n  color: #444;\n  padding: 14px 18px;\n  border-bottom: 1px solid #eaeaea;\n  vertical-align: middle;\n  font-size: 14px;\n}\n\n/* First row highlight */\n.highlight-row {\n  background-color: #e8f4fd;\n}\n\n/* Status cell with icon */\n/* .status-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n} */\n.status-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  min-height: 48px;      /* force uniform row height */\n  white-space: nowrap;  /* prevent ugly wrap */\n}\n\n/* Icon */\n/* .status-icon-sm \n\n{\n  width: 20px;\n  height: 20px;\n} */\n.mobile-timeline-card {\n  max-width: 400px;\n  margin: 20px auto;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n  font-family: 'Segoe UI', sans-serif;\n  overflow: hidden;\n}\n\n.timeline-heading {\n  font-weight: 600;\n  font-size: 16px;\n  color: white;\n  background-color: #1D7C9C;\n  padding: 12px 16px;\n  text-align: center;\n}\n\n.eta-strip {\n  background-color: #e3f4fd;\n  color: #1D7C9C;\n  font-weight: 600;\n  font-size: 14px;\n  text-align: center;\n  padding: 10px 16px;\n  border-bottom: 1px solid #d0eaf5;\n}\n\n/* Timeline Grid */\n.mobile-tracking-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 20px 16px;\n}\n\n/* Each row is 3-part: left (status), center (line + icon), right (time + location) */\n.timeline-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.timeline-left,\n.timeline-right {\n  width: 40%;\n  font-size: 13px;\n}\n\n.timeline-left .step-title {\n  font-weight: 600;\n  color: #333;\n  text-align: right;\n}\n\n.timeline-right .step-datetime,\n.timeline-right .step-location {\n  color: #555;\n  text-align: left;\n  margin-bottom: 3px;\n}\n\n/* Center vertical icon/line */\n.timeline-center {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 80px; /* controls the space between circles */\n}\n\n.circle-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background-color: white;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #007bff; /* or gray if inactive */\n}\n\n.circle-icon img {\n  width: 35px;\n  height: 35px;\n  /* filter: brightness(0) invert(1); */\n}\n\n.vertical-line {\n  position: absolute;\n  top: 32px;\n  width: 2px;\n  height: calc(100% - 32px);\n  background-color: #1D7C9C;\n  z-index: 0;\n}\n.status-step {\n  flex: 1;\n  text-align: center;\n  position: relative;\n}\n\n/* .status-connector-gray {\n  position: absolute;\n  top: 65px;\n  left: 5%;\n  width: 100%;\n  height: 5px;\n  background-color: gray; \n  transform: translateX(50%);\n  z-index: 0;\n} */\n.status-connector-blue {\n  position: absolute;\n  top: 65px;\n  left: 9%;\n  width: 100%;\n  height: 5px;\n  background-color: #1d7c9c; /* blue */\n  transform: translateX(50%);\n  z-index: 0;\n}\n\n/* .status-connector-green {\n  position: absolute;\n  top: 65px;\n  left: 0%;\n  width: 100%;\n  height: 5px;\n  background-color: #28a745; \n  transform: translateX(50%);\n  z-index: 0;\n} */\n .status-connector-green,\n .status-connector-gray {\n   position: absolute;\n   top: 65px;\n   left: calc(50% + (var(--status-icon-size) / 2) - 2px);\n   width: calc(100% + 6px);\n   height: 5px;\n   z-index: 0;\n }\n.status-connector-green {\n  background-color: #28a745;\n}\n.status-connector-gray {\n  background-color: #ccc;\n}\n\n.status-icon-wrapper {\n  width: 40px;\n  height: 40px;\n  background-color: #1d7c9c;\n  border-radius: 50%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n}\n\n.status-done {\n  background-color: #28a745 !important; /* green filled circle */\n}\n\n.status-icon {\n  width: 50px;\n  height: 50px;\n  z-index: 0;\n  /* filter: brightness(0) invert(1);  */\n}\n.status-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.status-dot-space {\n  width: 8px; /* fixed width to reserve space */\n  height: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #2b78e4;\n  border-radius: 50%;\n}\n\n\n.status-connector-green-mobile {\n  position: absolute;\n  top: 50%; /* Starts from the center of the current circle */\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 4px;\n  height: calc(100% - 10px);          /* Stretches fully downward */\n  background-color: #28a745;\n  z-index: 0;\n}\n\n.status-connector-blue-mobile {\n  position: absolute;\n  top: 50%; /* Starts from the center of the current circle */\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 4px;\n  height: calc(100% - 10px);\n  background-color: #1d7c9c; /* blue */\n  z-index: 0;\n}\n\n.status-connector-gray-mobile {\n  position: absolute;\n  top: 50%; /* Starts from the center of the current circle */\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 4px;\n  height: calc(100% - 10px); /* Adjust height to reach next circle */\n  background-color: #ccc;\n  z-index: 0;\n}\n\n.invoice-details-head{\n  background-color: #1D7C9C;\n  color: #fff;\n  padding: 15px 20px;\n  display: flex;\n  justify-content: \"space-between\";\n  align-items: \"center\";\n  font-weight: \"600\";\n  font-size: \"16px\"\n}\n.pod-eye-icon {\n  margin-top: 8px; /* Space below delivered icon */\n  text-align: center;\n}\n\n.pod-eye-icon i {\n  cursor: pointer;\n  font-size: 18px;\n}\n.tracking-grid {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  font-family: \"Segoe UI\", sans-serif;\n}\n\n.tracking-grid-header,\n.tracking-grid-row {\n  display: grid;\n  grid-template-columns: 1.2fr 1.5fr 1fr 1.5fr;\n  padding: 14px 18px;\n  border-bottom: 1px solid #eaeaea;\n  align-items: center;\n}\n\n.tracking-grid-header {\n  background-color: #f5f6f8;\n  font-weight: bold;\n  color: #333;\n  font-size: 14px;\n}\n\n.tracking-grid-row {\n  font-size: 14px;\n  color: #444;\n}\n\n.highlight-row {\n  background-color: #eaf6ff;\n}\n\n.status-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.date-cell {\n  white-space: nowrap;\n}\n\n.tracking-grid-expand {\n  padding: 15px 30px;\n  background: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
